import { combineReducers } from 'redux';
import { ActivityRunAction, ActivityRunActionType } from '../../actions/activityRunActions';

const loading = (state = false, action: ActivityRunAction) => {
  switch (action.type) {
    case ActivityRunActionType.GET_ACTIVITY_RUN_CONSOLE:
      return true;
    case ActivityRunActionType.GET_ACTIVITY_RUN_CONSOLE_OK:
    case ActivityRunActionType.GET_ACTIVITY_RUN_CONSOLE_ERROR:
      return false;
    default:
      return state;
  }
};

const loadingError = (state = '', action: ActivityRunAction) => {
  switch (action.type) {
    case ActivityRunActionType.GET_ACTIVITY_RUN_CONSOLE:
      return '';
    case ActivityRunActionType.GET_ACTIVITY_RUN_CONSOLE_ERROR:
      return action.error;
    default:
      return state;
  }
};

export default combineReducers({ loading, loadingError });
